import buildClientAPI from 'views/providers/clientAPI'
import { IState } from 'types/redux'
import {
  addCheckoutErrorAction,
  getOrderDraftId,
  getOrderId,
  getMountPointsInstance
} from './common'
import { getRedPointsStatus, getRegisterForRedPoints } from './redpoints'
import { REDPOINTS_SUBSCRIPTION_STATUS_NO_MEMBER } from 'shared/consts/redpointsSubscription'

// ---------------------------- ACTION TYPES -------------------------

export const SUBMIT_ORDER_SUCCESS: string = 'SUBMIT_ORDER_SUCCESS'

// ---------------------------- ACTIONS -------------------------

export const submitOrderSuccessAction = () => ({
  type: SUBMIT_ORDER_SUCCESS
})

// ---------------------------- THUNKS -------------------------

export const submitOrderAction = (): ((
  dispatch: Function,
  getState: () => IState
) => Promise<void>) => {
  return async (dispatch: Function, getState: () => IState) => {
    try {
      const state = getState()
      const orderDraftId = getOrderDraftId(state)
      const isRedPointsRegistrationMarked =
        getRedPointsStatus(state) === REDPOINTS_SUBSCRIPTION_STATUS_NO_MEMBER &&
        !!getRegisterForRedPoints(state)
      const { checkoutService } = buildClientAPI()

      const order = await checkoutService.submitOrder({
        isRedPointsRegistrationMarked,
        orderDraftId
      })

      dispatch(submitOrderSuccessAction())

      const orderNumber = getOrderId(order)

      window.location.assign(
        getMountPointsInstance().getConfirmation(orderNumber)
      )
    } catch (e) {
      dispatch(addCheckoutErrorAction(`submitOrderAction: ${e.message}`))
    }
  }
}
